// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Server overview cards for public homepage */
.server-overview {
  display: grid;
  gap: 18px;
  margin-top: 20px;
}

.server-section {
  padding: 0 20px 0 0;
}

.server-section h3 {
  margin: 0 0 16px 0;
  color: #f8fafc;
  font-size: 16px;
}

.server-card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(260px, 1fr));
  gap: 16px;
}

.server-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(168deg, rgba(10, 22, 41, 0.98), rgba(5, 12, 24, 0.96));
  border: 1px solid rgba(125, 151, 178, 0.18);
  border-radius: 18px;
  padding: 18px;
  display: grid;
  gap: 12px;
  min-height: 320px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.card-accent {
  position: absolute;
  inset: 0 0 auto 0;
  height: 3px;
  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));
}

.server-card-top {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 0 12px;
}

.server-card-top .server-name {
  grid-column: 1;
  grid-row: 1;
  font-weight: 700;
  color: #f8fafc;
  font-size: 1.05rem;
  align-self: center;
}

.server-card-top .top-badges {
  grid-column: 2;
  grid-row: 1;
  align-self: start;
}

.server-subtitle {
  grid-column: 1 / -1;
  grid-row: 2;
  margin-top: 6px;
  color: #94a3b8;
  font-size: 0.9rem;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.14);
  color: #e2e8f0;
  padding: 6px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.status-pill.is-live {
  background: rgba(16, 185, 129, 0.16);
  color: #86efac;
}

.session-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.session-meta-pill {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex: 1 1 140px;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(96, 165, 250, 0.18);
  color: #f8fafc;
}

.session-pill-label {
  color: #94a3b8;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.players-bulb {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.16);
  color: #bbf7d0;
  font-weight: 700;
  white-space: nowrap;
  flex-wrap: nowrap;
  min-width: max-content;
  font-size: smaller;
}

.players-bulb-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 10px rgba(74, 222, 128, 0.45);
}

.session-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 10px;
}

.session-card {
  background: rgba(148, 163, 184, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 12px;
  padding: 8px;
  min-height: 74px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  font-size: small;
  text-align: center;
}

.session-card.is-active {
  border-color: color-mix(in srgb, var(--accent-start) 45%, transparent);
  background: linear-gradient(180deg, color-mix(in srgb, var(--accent-start) 25%, transparent), color-mix(in srgb, var(--accent-start) 10%, transparent));
}

.session-card-label {
  font-size: 0.6rem;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.session-card-value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #f8fafc;
}

.session-badge {
  display: inline-flex;
  align-self: flex-start;
  font-size: 0.72rem;
  color: #67e8f9;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.server-details {
  display: grid;
  gap: 6px;
}

.small-meta {
  color: #cbd5e1;
  font-size: 0.9rem;
  line-height: 1.4;
}

.pit-stop-rules {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.pit-stop-icon {
  position: relative;
  display: inline-flex;
  color: var(--text-primary, #e2e8f0);
}

.pit-stop-icon.is-disabled {
  color: #64748b;
}

.pit-stop-icon-strike {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 125%;
  height: 1.5px;
  background: currentColor;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.pit-window-badge {
  padding: 1px 5px;
  border: 1px solid currentColor;
  border-radius: 3px;
  font-size: 11px;
  line-height: 1.3;
}

.detail-kicker {
  display: inline-block;
  min-width: 44px;
  color: #94a3b8;
  margin-right: 6px;
}

.weather-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e2e8f0;
  font-size: 0.95rem;
}

.detail-value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #f8fafc;
}

.progress-card {
  display: grid;
  gap: 8px;
}

.progress-head {
  display: flex;
  justify-content: space-between;
  color: #e2e8f0;
  font-size: 0.9rem;
}

.progress-wrap {
  width: 100%;
  background: rgba(255, 255, 255, 0.06);
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--progress-start), var(--progress-end));
  transition: width 200ms ease;
}

.top-badges {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.championship-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: rgba(250, 204, 21, 0.16);
  color: #fde68a;
}

.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}

.button-secondary,
.button-ghost,
.icon-button {
  border: none;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.button-secondary {
  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));
  color: white;
  padding: 8px 11px;
}

.button-ghost {
  background: rgba(148, 163, 184, 0.12);
  color: #e2e8f0;
  padding: 8px 11px;
}

.icon-button {
  background: rgba(148, 163, 184, 0.14);
  color: #f8fafc;
  padding: 8px 10px;
  font-size: 1rem;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2000;
}

.modal-card {
  width: min(92vw, 470px);
  max-height: min(86vh, 720px);
  overflow: auto;
  background: linear-gradient(180deg, rgba(9, 18, 35, 0.98), rgba(6, 12, 24, 0.98));
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.3);
}

.live-data-card {
  width: min(96vw, 900px);
}

.live-data-card--broadcast {
  width: min(98vw, 1400px);
  max-height: min(92vh, 860px);
}

.modal-card .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.modal-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.modal-card .modal-header h4 {
  margin: 0;
  color: #f8fafc;
  font-size: 1rem;
}

.modal-card .modal-header p {
  margin: 3px 0 0;
  color: #94a3b8;
  font-size: 0.9rem;
}

.search-field {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 10px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(148, 163, 184, 0.18);
  color: #cbd5e1;
}

.search-field input {
  border: none;
  outline: none;
  width: 100%;
  background: transparent;
  color: #f8fafc;
}

.car-list {
  display: grid;
  gap: 8px;
  max-height: 320px;
  overflow: auto;
  padding-right: 4px;
}

.car-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(148, 163, 184, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.16);
  color: #f8fafc;
}

.car-chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));
}

.modal-empty {
  color: #94a3b8;
  padding: 12px 0;
}

.live-data-table {
  display: grid;
  gap: 6px;
}

.live-data-header,
.live-data-row {
  display: grid;
  grid-template-columns: 44px 1.5fr 1.2fr 0.8fr 0.8fr 32px;
  gap: 8px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 10px;
}

.live-data-header {
  color: #94a3b8;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  background: rgba(148, 163, 184, 0.08);
}

.live-data-row {
  color: #e2e8f0;
  background: rgba(15, 23, 42, 0.72);
}

.collision-pill {
  display: inline-flex;
  color: #fda4af;
}

.no-servers {
  color: #94a3b8;
}

/* Telemetry tabs */
.telemetry-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.telemetry-tab {
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: rgba(148, 163, 184, 0.08);
  color: #94a3b8;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.telemetry-tab:hover:not(:disabled) {
  background: rgba(148, 163, 184, 0.14);
  color: #cbd5e1;
}

.telemetry-tab.active {
  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));
  color: white;
}

.telemetry-tab.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Telemetry table */
.telemetry-table-container {
  max-height: 520px;
  overflow-y: auto;
}

.telemetry-table {
  display: grid;
  gap: 4px;
}

.telemetry-header,
.telemetry-row {
  display: grid;
  grid-template-columns: 42px 1.8fr 60px 1.4fr 0.9fr 0.9fr 80px 70px;
  gap: 8px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.88rem;
}

.telemetry-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(15, 23, 42, 0.96);
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
}

.telemetry-row {
  background: rgba(15, 23, 42, 0.6);
  color: #e2e8f0;
  cursor: pointer;
  transition: background 0.15s ease;
}

.telemetry-row:hover {
  background: rgba(15, 23, 42, 0.85);
}

.telemetry-row.expanded {
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

/* Column sizing helpers */
.col-pos {
  text-align: center;
  font-weight: 700;
}

.telemetry-table .col-driver {
  font-weight: 600;
}

.telemetry-table .col-car-num {
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.telemetry-table .col-car,
.telemetry-table .col-best,
.telemetry-table .col-last,
.telemetry-table .col-laps,
.telemetry-table .col-pitstops {
    font-variant-numeric: tabular-nums;
    width: inherit;
    text-align: inherit;
    font-family: inherit;
}

.telemetry-table .col-status {
  font-size: inherit;
}

.telemetry-table .col-events {
  display: flex;
  gap: 6px;
  align-items: center;
}

/* Event icons */
.event-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.collision-icon {
  color: #fca5a5;
}

.position-change {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 0.85rem;
  font-weight: 700;
}

.position-change.gained {
  color: #86efac;
}

.position-change.lost {
  color: #fca5a5;
}

/* Lap details panel */
.lap-details-panel {
  grid-column: 1 / -1;
  background: rgba(5, 12, 24, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 8px;
  padding: 12px;
  margin-top: -2px;
  display: grid;
  gap: 4px;
  font-size: 0.85rem;
}

.lap-details-header,
.lap-detail-row {
  display: grid;
  grid-template-columns: 50px 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  padding: 6px 8px;
  align-items: center;
}

.lap-details-panel > .lap-details-header {
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  padding-bottom: 8px;
}

.lap-details-panel > .lap-detail-row {
  color: #cbd5e1;
  border-radius: 6px;
}

.lap-detail-row:hover {
  background: rgba(148, 163, 184, 0.06);
}

/* Lap-level event badges in the expanded lap view */
.lap-events {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.lap-event {
  display: inline-flex;
  align-items: center;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 1.4;
}

.lap-event-pit {
  background: rgba(251, 191, 36, 0.18);
  color: #fbbf24;
  border: 1px solid rgba(251, 191, 36, 0.35);
}

/* Race progression chart (reused from RaceResultsViewer) */
.race-progression-content {
  padding: 12px 0;
}

.progression-chart-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.progression-svg {
  width: 100%;
  height: auto;
  background-color: rgba(15, 23, 42, 0.6);
  border-radius: 8px;
  border: 1px solid #1e293b;
}

.chart-axis-label {
  font-size: 10px;
  fill: #64748b;
  font-family: 'Courier New', monospace;
}

.chart-axis-label-grid {
  fill: #475569;
  font-style: italic;
}

.progression-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.progression-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background-color: rgba(30, 41, 59, 0.7);
  border: 1px solid rgba(51, 65, 85, 0.6);
  color: #cbd5e1;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.15s, background-color 0.15s;
}

.progression-legend-item:hover {
  background-color: rgba(51, 65, 85, 0.8);
}

.progression-legend-item.hidden {
  opacity: 0.45;
}

.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background 0.15s;
}

/* Session ended banner */
.session-ended-banner {
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  text-align: center;
}

.session-ended-banner h3 {
  margin: 0 0 6px 0;
  color: #fbbf24;
  font-size: 1.4rem;
  letter-spacing: 0.1em;
}

.session-ended-banner p {
  margin: 0;
  color: #fde68a;
  font-size: 0.9rem;
}

/* Wide layout for race sessions with extra columns */
.telemetry-header.race-layout,
.telemetry-row.race-layout {
  grid-template-columns: 42px 1.8fr 60px 1.4fr 0.9fr 0.9fr 70px 70px 80px 90px;
}

/* ── Broadcast toggle button ── */
.broadcast-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.broadcast-btn--active {
  background: linear-gradient(90deg, color-mix(in srgb, var(--accent-start) 30%, transparent), color-mix(in srgb, var(--accent-end) 30%, transparent));
  color: #f0fdfa;
}

/* ── Live modal broadcast layout ── */
.live-modal-broadcast-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  min-height: 0;
  flex: 1 1;
}

.live-modal-stream {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.live-modal-stream .theater-video {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
  aspect-ratio: 16 / 9;
  width: 100%;
}

.live-modal-stream .theater-video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.live-modal-telemetry {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.live-modal-telemetry .telemetry-table-container {
  flex: 1 1;
  min-height: 0;
  max-height: calc(92vh - 200px);
  overflow-y: auto;
}

@media (max-width: 900px) {
  .live-modal-broadcast-layout {
    grid-template-columns: 1fr;
  }
}

/* ── Light-theme overrides ─────────────────────────────────────────────────── */

body.light-theme .server-section h3 {
  color: var(--text);
}

body.light-theme .server-card,
body.light-theme .championship-card {
  background: var(--surface-strong);
  border-color: var(--border);
  box-shadow: none;
}

body.light-theme .championship-card:hover {
  border-color: color-mix(in srgb, var(--accent-start) 30%, var(--border));
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--accent-start) 20%, transparent), var(--card-shadow);
}

body.light-theme .server-card-top .server-name,
body.light-theme .championship-card-top {
  color: var(--text);
}

body.light-theme .championship-card-top h3 {
  color: var(--text);
}

body.light-theme .server-subtitle,
body.light-theme .championship-subtitle {
  color: var(--muted);
}

body.light-theme .status-pill {
  background: rgba(15, 23, 42, 0.07);
  color: var(--muted-strong);
}

body.light-theme .status-pill.is-live {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
}

body.light-theme .status-pill.live {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
}

body.light-theme .status-pill.upcoming {
  background: rgba(14, 165, 233, 0.12);
  color: #0369a1;
}

body.light-theme .status-pill.ended {
  background: rgba(244, 63, 94, 0.1);
  color: #be123c;
}

body.light-theme .session-meta-pill,
body.light-theme .info-pill {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}

body.light-theme .info-pill.is-full {
  border-color: rgba(220, 38, 38, 0.3);
}

body.light-theme .session-pill-label,
body.light-theme .pill-label {
  color: var(--muted);
}

body.light-theme .pill-value {
  color: var(--text);
}

body.light-theme .players-bulb {
  background: rgba(34, 197, 94, 0.12);
  color: #16a34a;
}

body.light-theme .info-pill.is-full .players-bulb {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

body.light-theme .info-pill.is-full .players-bulb-dot {
  background: #dc2626;
  box-shadow: 0 0 8px rgba(220, 38, 38, 0.3);
}

body.light-theme .session-card {
  background: rgba(15, 23, 42, 0.05);
  border-color: var(--border);
}

body.light-theme .session-card-label {
  color: var(--muted);
}

body.light-theme .session-card-value {
  color: var(--text);
}

body.light-theme .session-badge {
  color: #0891b2;
}

body.light-theme .small-meta {
  color: var(--muted-strong);
}

body.light-theme .detail-kicker {
  color: var(--muted);
}

body.light-theme .weather-label {
  color: var(--text);
}

body.light-theme .detail-value {
  color: var(--text);
}

body.light-theme .progress-head {
  color: var(--text);
}

body.light-theme .progress-wrap {
  background: rgba(15, 23, 42, 0.08);
}

body.light-theme .championship-details {
  border-top-color: var(--border);
  border-bottom-color: var(--border);
}

body.light-theme .detail-label {
  color: var(--muted);
}

body.light-theme .progress-bar {
  background: rgba(15, 23, 42, 0.08);
}

body.light-theme .championship-button.secondary {
  background: rgba(15, 23, 42, 0.07);
  color: var(--text);
}

body.light-theme .button-ghost {
  background: rgba(15, 23, 42, 0.07);
  color: var(--text);
}

body.light-theme .icon-button {
  background: rgba(15, 23, 42, 0.07);
  color: var(--text);
}

body.light-theme .modal-card {
  background: var(--surface);
  border-color: var(--border);
}

body.light-theme .modal-card .modal-header h4 {
  color: var(--text);
}

body.light-theme .modal-card .modal-header p {
  color: var(--muted);
}

body.light-theme .search-field {
  background: var(--surface-strong);
  border-color: var(--border);
  color: var(--muted-strong);
}

body.light-theme .search-field input {
  color: var(--text);
}

body.light-theme .car-chip {
  background: var(--surface-strong);
  border-color: var(--border);
  color: var(--text);
}

body.light-theme .modal-empty {
  color: var(--muted);
}

body.light-theme .live-data-header {
  background: rgba(15, 23, 42, 0.06);
  color: var(--muted);
}

body.light-theme .live-data-row {
  background: var(--surface-strong);
  color: var(--text);
}

body.light-theme .no-servers {
  color: var(--muted);
}

body.light-theme .telemetry-tab {
  background: rgba(15, 23, 42, 0.06);
  color: var(--muted);
}

body.light-theme .telemetry-tab:hover:not(:disabled) {
  background: rgba(15, 23, 42, 0.1);
  color: var(--muted-strong);
}

body.light-theme .telemetry-header {
  background: rgba(15, 23, 42, 0.06);
  color: var(--muted);
  border-bottom-color: var(--border);
}

body.light-theme .telemetry-row {
  background: var(--surface-strong);
  color: var(--text);
}

body.light-theme .telemetry-row:hover {
  background: rgba(15, 23, 42, 0.07);
}

body.light-theme .lap-details-panel {
  background: var(--surface);
  border-color: var(--border);
}

body.light-theme .lap-details-header {
  color: var(--muted);
  border-bottom-color: var(--border);
}

body.light-theme .lap-detail-row {
  color: var(--muted-strong);
}

body.light-theme .theater-panel {
  background: var(--surface-strong);
  border-color: var(--border);
}

@media (max-width: 1140px) {
  .server-card-grid {
    grid-template-columns: repeat(2, minmax(240px, 1fr));
  }

  .telemetry-header,
  .telemetry-row {
    grid-template-columns: 38px 1.5fr 55px 1.2fr 0.85fr 0.85fr 75px 65px;
    font-size: 0.82rem;
    padding: 8px 10px;
  }

  .telemetry-header.race-layout,
  .telemetry-row.race-layout {
    grid-template-columns: 38px 1.4fr 50px 1fr 0.8fr 0.8fr 60px 60px 70px 80px;
  }
}

@media (max-width: 768px) {
  .server-section{
    padding-right: 28px;
  }
}

@media (max-width: 780px) {
  .server-card-grid {
    grid-template-columns: 1fr;
  }

  .session-grid {
    grid-template-columns: 1fr;
  }

  .live-data-header,
  .live-data-row {
    grid-template-columns: 36px 1.2fr 0.9fr 0.7fr 0.7fr 26px;
    font-size: 0.85rem;
  }

  .telemetry-header,
  .telemetry-row {
    grid-template-columns: 34px 1.2fr 45px 1fr 0.8fr 0.8fr 70px 60px;
    font-size: 0.78rem;
    padding: 7px 8px;
  }

  .telemetry-header.race-layout,
  .telemetry-row.race-layout {
    grid-template-columns: 34px 1.1fr 42px 0.9fr 0.7fr 0.7fr 55px 55px 65px 70px;
  }

  .live-data-card {
    width: min(98vw, 860px);
  }

  .lap-details-header,
  .lap-detail-row {
    grid-template-columns: 40px 0.9fr 0.9fr 0.9fr 0.9fr 70px 90px;
    font-size: 0.8rem;
  }
}

/* ── Ended session card ── */
.server-card--ended {
  opacity: 0.85;
  border-color: rgba(245, 158, 11, 0.25);
}

.server-card--ended .card-accent {
  background: linear-gradient(180deg, rgba(245, 158, 11, 0.6) 0%, transparent 100%);
}

.status-pill--ended {
  background: rgba(245, 158, 11, 0.14);
  color: #fbbf24;
}

/* ── Driver-left (disconnected) row ── */
.telemetry-row.driver-left {
  opacity: 0.5;
  font-style: italic;
}

.telemetry-row.driver-left:hover {
  opacity: 0.7;
}

.left-badge {
  font-size: 0.75em;
  color: #94a3b8;
  font-style: normal;
}

body.light-theme .telemetry-row.driver-left {
  opacity: 0.45;
}

body.light-theme .left-badge {
  color: #64748b;
}

body.light-theme .status-pill--ended {
  background: rgba(217, 119, 6, 0.12);
  color: #b45309;
}

body.light-theme .server-card--ended {
  border-color: rgba(217, 119, 6, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerOverview.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kFAAkF;EAClF,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,uJAAuJ;AACzJ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8EAA8E;EAC9E,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,iFAAiF;EACjF,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,wDAAwD;EACxD,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,kEAAkE;EAClE,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;;;;IAKI,kCAAkC;IAClC,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,2DAA2D;AAC3D;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;EACvC,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;;EAEE,4EAA4E;AAC9E;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oJAAoJ;EACpJ,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,iFAAiF;;AAEjF;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,kGAAkG;AACpG;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;;IAEE,oEAAoE;IACpE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,0EAA0E;EAC5E;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,wDAAwD;IACxD,kBAAkB;EACpB;;EAEA;;IAEE,gEAAgE;IAChE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,4EAA4E;EAC9E;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,6DAA6D;IAC7D,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Server overview cards for public homepage */\r\n.server-overview {\r\n  display: grid;\r\n  gap: 18px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.server-section {\r\n  padding: 0 20px 0 0;\r\n}\r\n\r\n.server-section h3 {\r\n  margin: 0 0 16px 0;\r\n  color: #f8fafc;\r\n  font-size: 16px;\r\n}\r\n\r\n.server-card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(260px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.server-card {\r\n  position: relative;\r\n  overflow: hidden;\r\n  background: linear-gradient(168deg, rgba(10, 22, 41, 0.98), rgba(5, 12, 24, 0.96));\r\n  border: 1px solid rgba(125, 151, 178, 0.18);\r\n  border-radius: 18px;\r\n  padding: 18px;\r\n  display: grid;\r\n  gap: 12px;\r\n  min-height: 320px;\r\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);\r\n}\r\n\r\n.card-accent {\r\n  position: absolute;\r\n  inset: 0 0 auto 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));\r\n}\r\n\r\n.server-card-top {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  grid-template-rows: auto auto;\r\n  gap: 0 12px;\r\n}\r\n\r\n.server-card-top .server-name {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  font-weight: 700;\r\n  color: #f8fafc;\r\n  font-size: 1.05rem;\r\n  align-self: center;\r\n}\r\n\r\n.server-card-top .top-badges {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  align-self: start;\r\n}\r\n\r\n.server-subtitle {\r\n  grid-column: 1 / -1;\r\n  grid-row: 2;\r\n  margin-top: 6px;\r\n  color: #94a3b8;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.status-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 999px;\r\n  background: rgba(148, 163, 184, 0.14);\r\n  color: #e2e8f0;\r\n  padding: 6px 10px;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.status-pill.is-live {\r\n  background: rgba(16, 185, 129, 0.16);\r\n  color: #86efac;\r\n}\r\n\r\n.session-meta {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.session-meta-pill {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  flex: 1 1 140px;\r\n  padding: 8px 10px;\r\n  border-radius: 12px;\r\n  background: rgba(15, 23, 42, 0.8);\r\n  border: 1px solid rgba(96, 165, 250, 0.18);\r\n  color: #f8fafc;\r\n}\r\n\r\n.session-pill-label {\r\n  color: #94a3b8;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.players-bulb {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border-radius: 999px;\r\n  background: rgba(34, 197, 94, 0.16);\r\n  color: #bbf7d0;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  flex-wrap: nowrap;\r\n  min-width: max-content;\r\n  font-size: smaller;\r\n}\r\n\r\n.players-bulb-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #4ade80;\r\n  box-shadow: 0 0 10px rgba(74, 222, 128, 0.45);\r\n}\r\n\r\n.session-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.session-card {\r\n  background: rgba(148, 163, 184, 0.08);\r\n  border: 1px solid rgba(148, 163, 184, 0.16);\r\n  border-radius: 12px;\r\n  padding: 8px;\r\n  min-height: 74px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  justify-content: center;\r\n  font-size: small;\r\n  text-align: center;\r\n}\r\n\r\n.session-card.is-active {\r\n  border-color: color-mix(in srgb, var(--accent-start) 45%, transparent);\r\n  background: linear-gradient(180deg, color-mix(in srgb, var(--accent-start) 25%, transparent), color-mix(in srgb, var(--accent-start) 10%, transparent));\r\n}\r\n\r\n.session-card-label {\r\n  font-size: 0.6rem;\r\n  color: #94a3b8;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n}\r\n\r\n.session-card-value {\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  color: #f8fafc;\r\n}\r\n\r\n.session-badge {\r\n  display: inline-flex;\r\n  align-self: flex-start;\r\n  font-size: 0.72rem;\r\n  color: #67e8f9;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.server-details {\r\n  display: grid;\r\n  gap: 6px;\r\n}\r\n\r\n.small-meta {\r\n  color: #cbd5e1;\r\n  font-size: 0.9rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.pit-stop-rules {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n}\r\n\r\n.pit-stop-icon {\r\n  position: relative;\r\n  display: inline-flex;\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.pit-stop-icon.is-disabled {\r\n  color: #64748b;\r\n}\r\n\r\n.pit-stop-icon-strike {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  width: 125%;\r\n  height: 1.5px;\r\n  background: currentColor;\r\n  transform: translate(-50%, -50%) rotate(-45deg);\r\n}\r\n\r\n.pit-window-badge {\r\n  padding: 1px 5px;\r\n  border: 1px solid currentColor;\r\n  border-radius: 3px;\r\n  font-size: 11px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.detail-kicker {\r\n  display: inline-block;\r\n  min-width: 44px;\r\n  color: #94a3b8;\r\n  margin-right: 6px;\r\n}\r\n\r\n.weather-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #e2e8f0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.detail-value {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #f8fafc;\r\n}\r\n\r\n.progress-card {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.progress-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  color: #e2e8f0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.progress-wrap {\r\n  width: 100%;\r\n  background: rgba(255, 255, 255, 0.06);\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, var(--progress-start), var(--progress-end));\r\n  transition: width 200ms ease;\r\n}\r\n\r\n.top-badges {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.championship-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 999px;\r\n  background: rgba(250, 204, 21, 0.16);\r\n  color: #fde68a;\r\n}\r\n\r\n.card-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.button-secondary,\r\n.button-ghost,\r\n.icon-button {\r\n  border: none;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: 600;\r\n}\r\n\r\n.button-secondary {\r\n  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));\r\n  color: white;\r\n  padding: 8px 11px;\r\n}\r\n\r\n.button-ghost {\r\n  background: rgba(148, 163, 184, 0.12);\r\n  color: #e2e8f0;\r\n  padding: 8px 11px;\r\n}\r\n\r\n.icon-button {\r\n  background: rgba(148, 163, 184, 0.14);\r\n  color: #f8fafc;\r\n  padding: 8px 10px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(2, 6, 23, 0.72);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  z-index: 2000;\r\n}\r\n\r\n.modal-card {\r\n  width: min(92vw, 470px);\r\n  max-height: min(86vh, 720px);\r\n  overflow: auto;\r\n  background: linear-gradient(180deg, rgba(9, 18, 35, 0.98), rgba(6, 12, 24, 0.98));\r\n  border: 1px solid rgba(148, 163, 184, 0.2);\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.live-data-card {\r\n  width: min(96vw, 900px);\r\n}\r\n\r\n.live-data-card--broadcast {\r\n  width: min(98vw, 1400px);\r\n  max-height: min(92vh, 860px);\r\n}\r\n\r\n.modal-card .modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.modal-header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.modal-card .modal-header h4 {\r\n  margin: 0;\r\n  color: #f8fafc;\r\n  font-size: 1rem;\r\n}\r\n\r\n.modal-card .modal-header p {\r\n  margin: 3px 0 0;\r\n  color: #94a3b8;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.search-field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  margin-bottom: 10px;\r\n  border-radius: 12px;\r\n  background: rgba(15, 23, 42, 0.8);\r\n  border: 1px solid rgba(148, 163, 184, 0.18);\r\n  color: #cbd5e1;\r\n}\r\n\r\n.search-field input {\r\n  border: none;\r\n  outline: none;\r\n  width: 100%;\r\n  background: transparent;\r\n  color: #f8fafc;\r\n}\r\n\r\n.car-list {\r\n  display: grid;\r\n  gap: 8px;\r\n  max-height: 320px;\r\n  overflow: auto;\r\n  padding-right: 4px;\r\n}\r\n\r\n.car-chip {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  border-radius: 12px;\r\n  background: rgba(148, 163, 184, 0.08);\r\n  border: 1px solid rgba(148, 163, 184, 0.16);\r\n  color: #f8fafc;\r\n}\r\n\r\n.car-chip-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));\r\n}\r\n\r\n.modal-empty {\r\n  color: #94a3b8;\r\n  padding: 12px 0;\r\n}\r\n\r\n.live-data-table {\r\n  display: grid;\r\n  gap: 6px;\r\n}\r\n\r\n.live-data-header,\r\n.live-data-row {\r\n  display: grid;\r\n  grid-template-columns: 44px 1.5fr 1.2fr 0.8fr 0.8fr 32px;\r\n  gap: 8px;\r\n  align-items: center;\r\n  padding: 8px 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.live-data-header {\r\n  color: #94a3b8;\r\n  font-size: 0.82rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  background: rgba(148, 163, 184, 0.08);\r\n}\r\n\r\n.live-data-row {\r\n  color: #e2e8f0;\r\n  background: rgba(15, 23, 42, 0.72);\r\n}\r\n\r\n.collision-pill {\r\n  display: inline-flex;\r\n  color: #fda4af;\r\n}\r\n\r\n.no-servers {\r\n  color: #94a3b8;\r\n}\r\n\r\n/* Telemetry tabs */\r\n.telemetry-tabs {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-bottom: 16px;\r\n  overflow-x: auto;\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.telemetry-tab {\r\n  padding: 8px 14px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: rgba(148, 163, 184, 0.08);\r\n  color: #94a3b8;\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.telemetry-tab:hover:not(:disabled) {\r\n  background: rgba(148, 163, 184, 0.14);\r\n  color: #cbd5e1;\r\n}\r\n\r\n.telemetry-tab.active {\r\n  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));\r\n  color: white;\r\n}\r\n\r\n.telemetry-tab.disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Telemetry table */\r\n.telemetry-table-container {\r\n  max-height: 520px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.telemetry-table {\r\n  display: grid;\r\n  gap: 4px;\r\n}\r\n\r\n.telemetry-header,\r\n.telemetry-row {\r\n  display: grid;\r\n  grid-template-columns: 42px 1.8fr 60px 1.4fr 0.9fr 0.9fr 80px 70px;\r\n  gap: 8px;\r\n  align-items: center;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.telemetry-header {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  background: rgba(15, 23, 42, 0.96);\r\n  color: #94a3b8;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.12);\r\n}\r\n\r\n.telemetry-row {\r\n  background: rgba(15, 23, 42, 0.6);\r\n  color: #e2e8f0;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.telemetry-row:hover {\r\n  background: rgba(15, 23, 42, 0.85);\r\n}\r\n\r\n.telemetry-row.expanded {\r\n  background: rgba(16, 185, 129, 0.08);\r\n  border: 1px solid rgba(16, 185, 129, 0.2);\r\n}\r\n\r\n/* Column sizing helpers */\r\n.col-pos {\r\n  text-align: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.telemetry-table .col-driver {\r\n  font-weight: 600;\r\n}\r\n\r\n.telemetry-table .col-car-num {\r\n  text-align: center;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.telemetry-table .col-car,\r\n.telemetry-table .col-best,\r\n.telemetry-table .col-last,\r\n.telemetry-table .col-laps,\r\n.telemetry-table .col-pitstops {\r\n    font-variant-numeric: tabular-nums;\r\n    width: inherit;\r\n    text-align: inherit;\r\n    font-family: inherit;\r\n}\r\n\r\n.telemetry-table .col-status {\r\n  font-size: inherit;\r\n}\r\n\r\n.telemetry-table .col-events {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n/* Event icons */\r\n.event-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.collision-icon {\r\n  color: #fca5a5;\r\n}\r\n\r\n.position-change {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.position-change.gained {\r\n  color: #86efac;\r\n}\r\n\r\n.position-change.lost {\r\n  color: #fca5a5;\r\n}\r\n\r\n/* Lap details panel */\r\n.lap-details-panel {\r\n  grid-column: 1 / -1;\r\n  background: rgba(5, 12, 24, 0.92);\r\n  border: 1px solid rgba(148, 163, 184, 0.14);\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  margin-top: -2px;\r\n  display: grid;\r\n  gap: 4px;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.lap-details-header,\r\n.lap-detail-row {\r\n  display: grid;\r\n  grid-template-columns: 50px 1fr 1fr 1fr 1fr 1fr;\r\n  gap: 8px;\r\n  padding: 6px 8px;\r\n  align-items: center;\r\n}\r\n\r\n.lap-details-panel > .lap-details-header {\r\n  color: #94a3b8;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.lap-details-panel > .lap-detail-row {\r\n  color: #cbd5e1;\r\n  border-radius: 6px;\r\n}\r\n\r\n.lap-detail-row:hover {\r\n  background: rgba(148, 163, 184, 0.06);\r\n}\r\n\r\n/* Lap-level event badges in the expanded lap view */\r\n.lap-events {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  align-items: center;\r\n}\r\n\r\n.lap-event {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 1px 5px;\r\n  border-radius: 4px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n  line-height: 1.4;\r\n}\r\n\r\n.lap-event-pit {\r\n  background: rgba(251, 191, 36, 0.18);\r\n  color: #fbbf24;\r\n  border: 1px solid rgba(251, 191, 36, 0.35);\r\n}\r\n\r\n/* Race progression chart (reused from RaceResultsViewer) */\r\n.race-progression-content {\r\n  padding: 12px 0;\r\n}\r\n\r\n.progression-chart-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.progression-svg {\r\n  width: 100%;\r\n  height: auto;\r\n  background-color: rgba(15, 23, 42, 0.6);\r\n  border-radius: 8px;\r\n  border: 1px solid #1e293b;\r\n}\r\n\r\n.chart-axis-label {\r\n  font-size: 10px;\r\n  fill: #64748b;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.chart-axis-label-grid {\r\n  fill: #475569;\r\n  font-style: italic;\r\n}\r\n\r\n.progression-legend {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n.progression-legend-item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  background-color: rgba(30, 41, 59, 0.7);\r\n  border: 1px solid rgba(51, 65, 85, 0.6);\r\n  color: #cbd5e1;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s, background-color 0.15s;\r\n}\r\n\r\n.progression-legend-item:hover {\r\n  background-color: rgba(51, 65, 85, 0.8);\r\n}\r\n\r\n.progression-legend-item.hidden {\r\n  opacity: 0.45;\r\n}\r\n\r\n.legend-dot {\r\n  display: inline-block;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  transition: background 0.15s;\r\n}\r\n\r\n/* Session ended banner */\r\n.session-ended-banner {\r\n  background: rgba(245, 158, 11, 0.12);\r\n  border: 1px solid rgba(245, 158, 11, 0.3);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.session-ended-banner h3 {\r\n  margin: 0 0 6px 0;\r\n  color: #fbbf24;\r\n  font-size: 1.4rem;\r\n  letter-spacing: 0.1em;\r\n}\r\n\r\n.session-ended-banner p {\r\n  margin: 0;\r\n  color: #fde68a;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Wide layout for race sessions with extra columns */\r\n.telemetry-header.race-layout,\r\n.telemetry-row.race-layout {\r\n  grid-template-columns: 42px 1.8fr 60px 1.4fr 0.9fr 0.9fr 70px 70px 80px 90px;\r\n}\r\n\r\n/* ── Broadcast toggle button ── */\r\n.broadcast-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.broadcast-btn--active {\r\n  background: linear-gradient(90deg, color-mix(in srgb, var(--accent-start) 30%, transparent), color-mix(in srgb, var(--accent-end) 30%, transparent));\r\n  color: #f0fdfa;\r\n}\r\n\r\n/* ── Live modal broadcast layout ── */\r\n.live-modal-broadcast-layout {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 16px;\r\n  min-height: 0;\r\n  flex: 1;\r\n}\r\n\r\n.live-modal-stream {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.live-modal-stream .theater-video {\r\n  position: relative;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: #000;\r\n  aspect-ratio: 16 / 9;\r\n  width: 100%;\r\n}\r\n\r\n.live-modal-stream .theater-video iframe {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n}\r\n\r\n.live-modal-telemetry {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.live-modal-telemetry .telemetry-table-container {\r\n  flex: 1;\r\n  min-height: 0;\r\n  max-height: calc(92vh - 200px);\r\n  overflow-y: auto;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .live-modal-broadcast-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* ── Light-theme overrides ─────────────────────────────────────────────────── */\r\n\r\nbody.light-theme .server-section h3 {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .server-card,\r\nbody.light-theme .championship-card {\r\n  background: var(--surface-strong);\r\n  border-color: var(--border);\r\n  box-shadow: none;\r\n}\r\n\r\nbody.light-theme .championship-card:hover {\r\n  border-color: color-mix(in srgb, var(--accent-start) 30%, var(--border));\r\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--accent-start) 20%, transparent), var(--card-shadow);\r\n}\r\n\r\nbody.light-theme .server-card-top .server-name,\r\nbody.light-theme .championship-card-top {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .championship-card-top h3 {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .server-subtitle,\r\nbody.light-theme .championship-subtitle {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .status-pill {\r\n  background: rgba(15, 23, 42, 0.07);\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .status-pill.is-live {\r\n  background: rgba(16, 185, 129, 0.12);\r\n  color: #059669;\r\n}\r\n\r\nbody.light-theme .status-pill.live {\r\n  background: rgba(16, 185, 129, 0.12);\r\n  color: #059669;\r\n}\r\n\r\nbody.light-theme .status-pill.upcoming {\r\n  background: rgba(14, 165, 233, 0.12);\r\n  color: #0369a1;\r\n}\r\n\r\nbody.light-theme .status-pill.ended {\r\n  background: rgba(244, 63, 94, 0.1);\r\n  color: #be123c;\r\n}\r\n\r\nbody.light-theme .session-meta-pill,\r\nbody.light-theme .info-pill {\r\n  background: var(--surface);\r\n  border-color: var(--border);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .info-pill.is-full {\r\n  border-color: rgba(220, 38, 38, 0.3);\r\n}\r\n\r\nbody.light-theme .session-pill-label,\r\nbody.light-theme .pill-label {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .pill-value {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .players-bulb {\r\n  background: rgba(34, 197, 94, 0.12);\r\n  color: #16a34a;\r\n}\r\n\r\nbody.light-theme .info-pill.is-full .players-bulb {\r\n  background: rgba(220, 38, 38, 0.1);\r\n  color: #dc2626;\r\n}\r\n\r\nbody.light-theme .info-pill.is-full .players-bulb-dot {\r\n  background: #dc2626;\r\n  box-shadow: 0 0 8px rgba(220, 38, 38, 0.3);\r\n}\r\n\r\nbody.light-theme .session-card {\r\n  background: rgba(15, 23, 42, 0.05);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .session-card-label {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .session-card-value {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .session-badge {\r\n  color: #0891b2;\r\n}\r\n\r\nbody.light-theme .small-meta {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .detail-kicker {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .weather-label {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .detail-value {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .progress-head {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .progress-wrap {\r\n  background: rgba(15, 23, 42, 0.08);\r\n}\r\n\r\nbody.light-theme .championship-details {\r\n  border-top-color: var(--border);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .detail-label {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .progress-bar {\r\n  background: rgba(15, 23, 42, 0.08);\r\n}\r\n\r\nbody.light-theme .championship-button.secondary {\r\n  background: rgba(15, 23, 42, 0.07);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .button-ghost {\r\n  background: rgba(15, 23, 42, 0.07);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .icon-button {\r\n  background: rgba(15, 23, 42, 0.07);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .modal-card {\r\n  background: var(--surface);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .modal-card .modal-header h4 {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .modal-card .modal-header p {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .search-field {\r\n  background: var(--surface-strong);\r\n  border-color: var(--border);\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .search-field input {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .car-chip {\r\n  background: var(--surface-strong);\r\n  border-color: var(--border);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .modal-empty {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .live-data-header {\r\n  background: rgba(15, 23, 42, 0.06);\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .live-data-row {\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .no-servers {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .telemetry-tab {\r\n  background: rgba(15, 23, 42, 0.06);\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .telemetry-tab:hover:not(:disabled) {\r\n  background: rgba(15, 23, 42, 0.1);\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .telemetry-header {\r\n  background: rgba(15, 23, 42, 0.06);\r\n  color: var(--muted);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .telemetry-row {\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .telemetry-row:hover {\r\n  background: rgba(15, 23, 42, 0.07);\r\n}\r\n\r\nbody.light-theme .lap-details-panel {\r\n  background: var(--surface);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .lap-details-header {\r\n  color: var(--muted);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .lap-detail-row {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .theater-panel {\r\n  background: var(--surface-strong);\r\n  border-color: var(--border);\r\n}\r\n\r\n@media (max-width: 1140px) {\r\n  .server-card-grid {\r\n    grid-template-columns: repeat(2, minmax(240px, 1fr));\r\n  }\r\n\r\n  .telemetry-header,\r\n  .telemetry-row {\r\n    grid-template-columns: 38px 1.5fr 55px 1.2fr 0.85fr 0.85fr 75px 65px;\r\n    font-size: 0.82rem;\r\n    padding: 8px 10px;\r\n  }\r\n\r\n  .telemetry-header.race-layout,\r\n  .telemetry-row.race-layout {\r\n    grid-template-columns: 38px 1.4fr 50px 1fr 0.8fr 0.8fr 60px 60px 70px 80px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .server-section{\r\n    padding-right: 28px;\r\n  }\r\n}\r\n\r\n@media (max-width: 780px) {\r\n  .server-card-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .session-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .live-data-header,\r\n  .live-data-row {\r\n    grid-template-columns: 36px 1.2fr 0.9fr 0.7fr 0.7fr 26px;\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .telemetry-header,\r\n  .telemetry-row {\r\n    grid-template-columns: 34px 1.2fr 45px 1fr 0.8fr 0.8fr 70px 60px;\r\n    font-size: 0.78rem;\r\n    padding: 7px 8px;\r\n  }\r\n\r\n  .telemetry-header.race-layout,\r\n  .telemetry-row.race-layout {\r\n    grid-template-columns: 34px 1.1fr 42px 0.9fr 0.7fr 0.7fr 55px 55px 65px 70px;\r\n  }\r\n\r\n  .live-data-card {\r\n    width: min(98vw, 860px);\r\n  }\r\n\r\n  .lap-details-header,\r\n  .lap-detail-row {\r\n    grid-template-columns: 40px 0.9fr 0.9fr 0.9fr 0.9fr 70px 90px;\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n/* ── Ended session card ── */\r\n.server-card--ended {\r\n  opacity: 0.85;\r\n  border-color: rgba(245, 158, 11, 0.25);\r\n}\r\n\r\n.server-card--ended .card-accent {\r\n  background: linear-gradient(180deg, rgba(245, 158, 11, 0.6) 0%, transparent 100%);\r\n}\r\n\r\n.status-pill--ended {\r\n  background: rgba(245, 158, 11, 0.14);\r\n  color: #fbbf24;\r\n}\r\n\r\n/* ── Driver-left (disconnected) row ── */\r\n.telemetry-row.driver-left {\r\n  opacity: 0.5;\r\n  font-style: italic;\r\n}\r\n\r\n.telemetry-row.driver-left:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.left-badge {\r\n  font-size: 0.75em;\r\n  color: #94a3b8;\r\n  font-style: normal;\r\n}\r\n\r\nbody.light-theme .telemetry-row.driver-left {\r\n  opacity: 0.45;\r\n}\r\n\r\nbody.light-theme .left-badge {\r\n  color: #64748b;\r\n}\r\n\r\nbody.light-theme .status-pill--ended {\r\n  background: rgba(217, 119, 6, 0.12);\r\n  color: #b45309;\r\n}\r\n\r\nbody.light-theme .server-card--ended {\r\n  border-color: rgba(217, 119, 6, 0.3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
